import PropTypes from 'prop-types';

const CanView = ({ isVisible, children }) => isVisible && children;

CanView.propTypes = {
  isVisible: PropTypes.bool.isRequired,
};

export default CanView;
